import { render } from "./productionCountriesProviderDetailModal.vue?vue&type=template&id=9c3b979a&ts=true"
import script from "./productionCountriesProviderDetailModal.vue?vue&type=script&lang=ts"
export * from "./productionCountriesProviderDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__